(() => {
  const footer = document.querySelector("[data-onura-footer]");

  if (!footer) return;

  const toggles = footer.querySelectorAll("[data-onura-footer-toggle]");

  const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

  const closePanel = (toggle) => {
    const panel = toggle.parentElement?.querySelector("[data-onura-footer-panel]");

    toggle.setAttribute("aria-expanded", "false");

    if (panel) {
      panel.classList.remove("is-open");
    }
  };

  const openPanel = (toggle) => {
    const panel = toggle.parentElement?.querySelector("[data-onura-footer-panel]");

    toggle.setAttribute("aria-expanded", "true");

    if (panel) {
      panel.classList.add("is-open");
    }
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      if (!isMobile()) return;

      const isOpen = toggle.getAttribute("aria-expanded") === "true";

      toggles.forEach((otherToggle) => {
        if (otherToggle !== toggle) {
          closePanel(otherToggle);
        }
      });

      if (isOpen) {
        closePanel(toggle);
      } else {
        openPanel(toggle);
      }
    });
  });

  const handleResize = () => {
    if (!isMobile()) {
      toggles.forEach(openPanel);
    } else {
      toggles.forEach(closePanel);
    }
  };

  window.addEventListener("resize", handleResize);
  handleResize();
})();